"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Debug = void 0;
const createDebug = require("debug");
/**
 * Debug instance with the given namespace: http-proxy-middleware
 */
exports.Debug = createDebug('http-proxy-middleware');
